import type { StepsDetailsMap } from './types';

export const stepsDetails: StepsDetailsMap = {
  commands: {
    showActionBar: true,
  },
  commands_puppy: {
    showActionBar: true,
  },
  dog_name: {
    showActionBar: true,
  },
  mail: {
    showActionBar: true,
  },

  customV1_commands: {
    showActionBar: true,
  },
  customV1_concern: {
    showActionBar: true,
  },
  customV1_main_goal: {
    showActionBar: true,
  },

  customV1_descriptionV1: {
    continue: true,
  },
  customV1_descriptionV2: {
    continue: true,
  },
  customV1_loader: {
    continueAuto: true,
  },
  customV1_startPage: {
    continue: true,
  },
  customV2_policyPage: {
    continue: true,
  },
  customV2_policyPageV2: {
    continue: true,
  },
  customV2_policyPageV3: {
    continue: true,
  },
  customV2_policyPageV4: {
    continue: true,
  },
  customV2_policyPageV5: {
    continue: true,
  },
  customV2_policyPageV6: {
    continue: true,
  },
  customV2_videoPolicyPage: {
    continue: true,
  },
  // customV2_start_page_video: {
  //   continue: true,
  // },
  // customV2_start_page_video_v2: {
  //   continue: true,
  // },
  customV2_info_health: {
    continue: true,
  },
  customV2_info_puppy_easier: {
    continue: true,
  },
  customV2_info_puppy_blues: {
    continue: true,
  },
  customV2_info_breed: {
    continue: true,
  },
  info_about_worries: {
    continue: true,
  },
  customV2_info_breed_2: {
    continue: true,
  },
  customV2_info_breed_3: {
    continue: true,
  },
  customV2_plan: {
    continue: true,
  },
  customV2_info_predict: {
    continue: true,
  },
  customV2_startPage: {
    welcome_loader: true,
  },
  customV2_start_page_video: {
    welcome_loader: true,
  },
  customV2_startPageV2: {
    welcome_loader: true,
  },
  customV2_start_page_video_v2: {
    welcome_loader: true,
  },
  customV2_startPageV3: {
    welcome_loader: true,
  },
  info_thank: {
    continue: true,
  },
  info_about_potty: {
    continue: true,
  },
  customV2_startPageV4: {
    continue: true,
  },
  customV2_startPageV47: {
    continue: true,
  },
  info_about_owner: {
    continue: true,
  },
  customV2_startPageV5: {
    continue: true,
  },
  customV2_startPageV6: {
    continue: true,
  },
  customV2_quote: {
    continue: true,
  },
  customV2_specialOffer: {
    continue: true,
  },
  customV2_specialOffer_v2: {
    continue: true,
  },
  customV2_specialOffer_v3: {
    continue: true,
  },
  customV2_specialOffer_v4: {
    continue: true,
  },
  customV2_startPageV11: {
    welcome_loader: true,
  },
  customV2_startPageV12: {
    welcome_loader: true,
  },
  customV2_startPageV13: {
    welcome_loader: true,
  },
  customV2_startPageV18: {
    welcome_loader: true,
  },
  customV2_startPageV17: {
    continue: true,
  },
  customV2_startPageV21: {
    welcome_loader: true,
  },
  customV2_startPageV22: {
    welcome_loader: true,
  },
  customV2_startPageV23: {
    continue: true,
  },
  info_about_crate: {
    continue: true,
  },
  customV2_startPageV24: {
    welcome_loader: true,
  },
  info_about_potty_struggles: {
    continue: true,
  },
  behavior_signals: {
    continue: true,
  },
  info_about_training: {
    continue: true,
  },
  customV2_startPageV25: {
    continue: true,
  },
  customV2_startPageV26: {
    welcome_loader: true,
  },
  customV2_startPageV27: {
    continue: true,
  },
  customV2_startPageV28: {
    welcome_loader: true,
  },
  customV2_startPageV30: {
    continue: true,
  },
  customV2_startPageV31: {
    continue: true,
  },
  customV2_startPageV29: {
    welcome_loader: true,
  },
  customV2_startPageV32: {
    welcome_loader: true,
  },
  customV2_startPageV33: {
    welcome_loader: true,
  },
  customV2_startPageV41: {
    welcome_loader: true,
  },
  customV2_startPageV34: {
    welcome_loader: true,
  },
  customV2_startPageV35: {
    welcome_loader: true,
  },
  customV2_startPageV42: {
    welcome_loader: true,
  },
  customV2_startPageV43: {
    welcome_loader: true,
  },
  customV2_startPageV37: {
    welcome_loader: true,
  },
  customV2_startPageV38: {
    welcome_loader: true,
  },
  customV2_startPageV36: {
    welcome_loader: true,
  },
  customV2_startPageV39: {
    welcome_loader: true,
  },
  customV2_startPageV40: {
    welcome_loader: true,
  },
  customV2_startPageV44: {
    continue: true,
  },
  customV2_startPageV45: {
    welcome_loader: true,
  },
  customV2_startPageV46: {
    welcome_loader: true,
  },
  info_about_understanding: {
    continue: true,
  },
  understanding_summary: {
    continue: true,
  },
  info_about_nutrition: {
    continue: true,
  },
  info_about_food_scanner: {
    continue: true,
  },
  k9_info_personalization: {
    continue: true,
  },
};
